"use client";

import { useDeploymentConfig } from "~/app/_components/ConfigProvider";
import { DeploymentAssetImage } from "~/app/_components/DeploymentAssetImage";
import { getHeroImage } from "~/data/products";
import { remoteDeploymentAssetUrl } from "~/lib/deployment-assets";

export function HeroImage() {
  const { assetsBaseUrl } = useDeploymentConfig();
  const heroFilename = getHeroImage();
  const remoteUrl = remoteDeploymentAssetUrl(assetsBaseUrl, heroFilename);

  return (
    <DeploymentAssetImage
      filename={heroFilename}
      remoteUrl={remoteUrl}
      alt="Diaspora One marketplace"
      fill
      className="object-cover"
      priority
      sizes="(max-width: 768px) 100vw, 512px"
    />
  );
}
